import { isNotNullOrUndefined } from "common/data-util";
import { ConditionalComponentWrapper } from "components/common/ConditionalComponentWrapper";
import { ChargingAgreementPricing, ChargingThirdPartyCompensationOption, ChargingThirdPartyCompensationOptionType } from "models/charging/agreement";
import React from "react";

interface NewChargingAgreementCompensationCardProps {
  thirdPartyCompensationOption: ChargingThirdPartyCompensationOption;
  pricing: ChargingAgreementPricing;
}

export function NewChargingAgreementCompensationCard({
  thirdPartyCompensationOption,
  pricing
} : NewChargingAgreementCompensationCardProps){
  return (
    <div className="d-lg-flex justify-content-between align-items-center u-fs-16">
      <div className="d-flex flex-column flex-1">
          <div>
              <h2 className="mb-1">{thirdPartyCompensationOption.name}</h2>
              <p className="mb-1">{thirdPartyCompensationOption.description}</p>
          </div>
          <ConditionalComponentWrapper condition={thirdPartyCompensationOption.type === ChargingThirdPartyCompensationOptionType.NETO && isNotNullOrUndefined(pricing.thirdPartyCompensationNetoFeeEuros)}>
            <div className="row mt-1">
                  <div className="col">
                      <div className="row">
                          <div className="col-5 col-xl-4 col-xxl-3 text-gray-700 u-fs-14">Neto kompensatsioon:</div>
                          <div className="font-weight-bold">{pricing.thirdPartyCompensationNetoFeeEuros} €</div>
                      </div>         
                              
                  </div>
              </div>
              <div className="row mt-2">
                  <div className="col text-gray-700 u-fs-14">
                    Hindadele lisandub käibemaks
                  </div>
              </div>
          </ConditionalComponentWrapper>
      </div>
  </div>
  );
}